import './mobileAppBanner.css';
import appBanner from './search__hotel-js-template_appBanner.phtml';

export default appBanner;